// Template227: Kuala Lumpur - Día 3 Templos & KL Tower (Page10)
// Mapa arriba (iframe + tip + sticker) + contenido scroll: intro, Perdana Gardens, Mezquita Nacional + SabiasQue, Templo Thean Hou.

import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";
import { useMapFullscreen } from "../../context/MapFullscreenContext";

const Template227 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const [fullscreen, setFullscreen] = useState(false);
	const [loaded, setLoaded] = useState(false);
	const { setMapFullscreen } = useMapFullscreen() || {};

	useEffect(() => {
		if (typeof setMapFullscreen === "function") {
			setMapFullscreen(fullscreen);
			return () => setMapFullscreen(false);
		}
	}, [fullscreen, setMapFullscreen]);

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const mapTip = page?.texts?.[2]?.content;
	const block1Title = page?.texts?.[3]?.content;
	const block1Body = page?.texts?.[4]?.content;
	const block2Title = page?.texts?.[5]?.content;
	const block2Body = page?.texts?.[6]?.content;
	const block3Title = page?.texts?.[7]?.content;
	const block3Body = page?.texts?.[8]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const img1 = getImageSrc("img1");
	const img2 = getImageSrc("img2");
	const img3 = getImageSrc("img3");
	const mapSticker = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");

	const mapUrl = page?.maps?.[0] || "";
	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#2E7D5B";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		marginBottom: 0.5,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	const mapHeight = isSmallScreen ? 400 : 340;

	if (fullscreen && mapUrl) {
		return (
			<div
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<div
					style={{
						padding: "10px",
						textAlign: "right",
						backgroundColor: actualHeaderColor,
					}}
				>
					<button
						onClick={() => setFullscreen(false)}
						style={{
							backgroundColor: "#fff",
							color: actualHeaderColor,
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
							fontFamily: "'Poppins', sans-serif",
						}}
					>
						← Volver a la guía
					</button>
				</div>
				<iframe
					title="Mapa grande"
					src={mapUrl}
					width="100%"
					height="100%"
					style={{ border: 0, flex: 1 }}
					allowFullScreen
					loading="lazy"
				/>
			</div>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				overflow: "hidden",
			}}
		>
			<Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 9999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>

				{/* Mapa */}
				<Box data-block-id="map" sx={{ flexShrink: 0, marginTop: "-70px", position: "relative" }}>
				{mapUrl && (
					<>
						<iframe
							title="Mapa Día 3"
							src={mapUrl}
							width="100%"
							height={mapHeight}
							style={{ border: 0 }}
							loading="lazy"
							onLoad={() => setLoaded(true)}
						/>
						<button
							onClick={() => setFullscreen(true)}
							style={{
								position: "absolute",
								top: 80,
								right: 10,
								backgroundColor: actualHeaderColor,
								color: "#fff",
								padding: "8px 10px",
								fontSize: "11px",
								borderRadius: "8px",
								fontFamily: "'Poppins', sans-serif",
								boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",
								zIndex: 4,
								border: "none",
								cursor: "pointer",
							}}
						>
							Ver mapa grande
						</button>
					</>
				)}
				{mapTip && (
					<Box
						sx={{
							position: "absolute",
							bottom: 80,
							left: 5,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "16px 16px 16px 0px",
							padding: "10px 12px",
							fontSize: 11,
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 140,
							zIndex: 3,
						}}
					>
						{mapTip}
					</Box>
				)}
				{mapSticker && (
					<Box
						component="img"
						src={mapSticker}
						alt=""
						sx={{
							width: 100,
							position: "absolute",
							bottom: -10,
							left: -10,
							zIndex: 2,
						}}
					/>
				)}
			</Box>

			{/* Contenido debajo del mapa */}
			<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
				<Box data-block-id="text-2" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					{intro && (
						<Box component="p" sx={{ ...estiloP, color: "#333" }}>
							{intro}
						</Box>
					)}

					{/* Perdana Botanical Gardens */}
					<Box data-block-id="text-3" sx={{ display: "flex", gap: 2.5, alignItems: "flex-start" }}>
						{img1 && (
							<Box
								component="img"
								src={img1}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									borderRadius: "12px",
									objectFit: "cover",
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{block1Title && (
								<Box component="h3" sx={estiloH3}>
									{block1Title}
								</Box>
							)}
							{block1Body && (
								<Box component="p" sx={estiloP}>
									{block1Body}
								</Box>
							)}
						</Box>
					</Box>

					{/* Mezquita Nacional */}
					<Box
						data-block-id="text-4"
						sx={{
							display: "flex",
							gap: 2.5,
							alignItems: "flex-start",
							position: "relative",
						}}
					>
						{img2 && (
							<Box
								component="img"
								src={img2}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									borderRadius: "12px",
									objectFit: "cover",
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{block2Title && (
								<Box component="h3" sx={estiloH3}>
									{block2Title}
								</Box>
							)}
							{block2Body && (
								<Box component="p" sx={estiloP}>
									{block2Body}
								</Box>
							)}
						</Box>
						{sabiasQue[0] && (
							<Box sx={{ position: "absolute", top: -10, left: "33%" }}>
								<SabiasQue
									icono={sabiasQue[0].icono}
									texto={sabiasQue[0].texto}
								/>
							</Box>
						)}
					</Box>

					{/* Templo Thean Hou */}
					<Box data-block-id="text-5" sx={{ display: "flex", gap: 2.5, alignItems: "flex-start" }}>
						<Box sx={{ width: "60%" }}>
							{block3Title && (
								<Box component="h3" sx={estiloH3}>
									{block3Title}
								</Box>
							)}
							{block3Body && (
								<Box component="p" sx={estiloP}>
									{block3Body}
								</Box>
							)}
						</Box>
						{img3 && (
							<Box
								component="img"
								src={img3}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									borderRadius: "12px",
									objectFit: "cover",
								}}
							/>
						)}
					</Box>
				</Box>
			</Box>
			</Box>
		</Box>
	);
};

Template227.thumbnail = "/images/template-1.png";
export default Template227;
